module.exports = __webpack_public_path__ + "img/perfectMoney-on.0f2e9998.png";